<template>
  <div class="flex items-center gap-2">
    <span class="text-text-neutral-primary">Light</span>
    <FreeSwitch :checked="isDark" @onChange="toggleTheme" />
    <span class="text-text-neutral-primary">Dark</span>
  </div>
</template>

<script setup lang="ts">
  import { ref, onMounted } from 'vue';
  import { FreeSwitch } from 'freedom-shared';

  const isDark = ref(false);

  function applyTheme(theme: 'dark' | 'light') {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    localStorage.setItem('theme', theme);

    const url = new URL(window.location.href);
    url.searchParams.set('theme', theme);
    window.history.replaceState({}, '', url.toString());
  }

  onMounted(() => {
    const url = new URL(window.location.href);
    const urlTheme = url.searchParams.get('theme');
    const storedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)',
    ).matches;

    const theme = urlTheme || storedTheme || (prefersDark ? 'dark' : 'light');
    isDark.value = theme === 'dark';
    applyTheme(theme);
  });

  function toggleTheme() {
    const newTheme = isDark.value ? 'light' : 'dark';
    isDark.value = !isDark.value;
    applyTheme(newTheme);
  }
</script>
